module.exports = __webpack_public_path__ + "static/media/android.042e32c8.png";